<script setup lang="ts">
import { computed } from 'vue';
import { useTypedStore } from '@/store';
import _ from '@/setup/lodash';

//#region types
type NoteTag = (typeof noteTags.value)[number];

interface Props {
  availableNoteTags?: any[],
}
//#endregion

//#region define
const props = withDefaults(defineProps<Props>(), {
  availableNoteTags: () => [],
});
//#endregion

//#region state
const modelValue = defineModel<string>();
//#endregion

//#region const
const whiteElem: NoteTag = {
  content: 'white',
  id: 'null',
  type: 'colourful_circle',
};

const noColor: NoteTag = {
  content: 'no-color',
  id: 'undefined',
  type: 'colourful_circle',
};
//#endregion

//#region composables
const store = useTypedStore();
//#endregion

//#region computed
const noteTags = computed(() => store.getters['misc/noteTags']);
const tags = computed(() => {
  const tempArray = _.cloneDeep(noteTags.value);
  tempArray.unshift(whiteElem);
  tempArray.unshift(noColor);
  return tempArray.filter((item) => props.availableNoteTags.indexOf(item.content) > -1);
});
//#endregion
</script>

<template>
  <ElRadioGroup
    v-model="modelValue"
    class="color-tags"
  >
    <ElRadio
      v-for="(item, index) in tags"
      :key="index"
      :class="item.content"
      :value="item.id"
    />
  </ElRadioGroup>
</template>

<style lang="scss">
.color-tags {
  .el-radio {
    margin-right: 5px;
    margin-left: 0 !important;

    &__label {
      display: none;
    }

    .el-radio__inner {
      width: 22px;
      height: 22px;
      background-color: white;
      border: 1px solid white;

      &:hover {
        border-color: var(--border-focused);
      }

      &:after {
        display: none;
      }

      &:before {
        content: '';
        display: block;
        position: absolute;
        top: 50%;
        left: 50%;
        border-radius: 50%;
        width: 14px;
        height: 14px;
        background-color: white;
        border: 1px solid var(--border-default);
        transform: translate(-50%, -50%) scale(1);
      }
    }

    &.is-checked {
      .el-radio__inner {
        background-color: white;
        border-color: var(--border-focused);
      }
    }

    &.no-color{
      .el-radio__inner {
        &:after {
          border-radius: 0;
          width: 1px;
          display: block;
          height: calc(100% - 8px);
          background-color: var(--border-negative);
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) rotate(45deg);
        }
      }
    }

    &.green {
      .el-radio__inner {
        &:before {
          background-color: var(--background-positive);
          border: 1px solid var(--background-positive);
        }
      }
    }

    &.red {
      .el-radio__inner {
        &:before {
          background-color: var(--background-negative) !important;
          border: 1px solid var(--background-negative) !important;
        }
      }
    }

    &.yellow {
      .el-radio__inner {
        &:before {
          background-color: var(--background-warning);
          border: 1px solid var(--background-warning);
        }
      }
    }
  }
}
</style>
